module.exports = __webpack_public_path__ + "static/media/toyota-off-app-provider-icon.3604d688.svg";